function normalizeValues(obj) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, v == null ? '' : v]));
}

export { normalizeValues };
